export function formatStatus(rawStatus: string): {
  status: 'success' | 'pending' | 'failed';
  label: string;
} {
  switch (rawStatus) {
    case 'successful':
      return { status: 'success', label: 'Successful' };
    case 'failed':
      return { status: 'failed', label: 'Failed' };
    case 'pending':
    default:
      return { status: 'pending', label: 'Pending' };
  }
}
